import { Card, Container, Row } from "react-bootstrap";

import React from "react";

export const Contact = () => {
	const style = {
		minHeight: "100vh",
		paddingTop: '10vh',
	};
	const rowStyle = {
		marginTop: '2vh',
	};


	const emailAddress = "info@cantinaagu.it";
	const telNumber = "+39 3889428853";

	return (
		<div>
			<Container style={style}><Card>
				<Card.Body>
					<Row className="text-center" style={rowStyle}>
						<h3>Azienda agricola Agù Andrea Costanzo</h3>
					</Row>
					<Row className="text-center" style={rowStyle}>
						<h4>Sede:</h4>
						<p>
							Via San Defendente n. 42<br /> 12031, Bagnolo Piemonte, <br />Cuneo, Italy
						</p>
					</Row>
					<Row className="text-center" style={rowStyle}>
						<h4>Cantina:</h4>
						<p>
							Via Martra n. 11<br /> 12031, Bagnolo Piemonte, <br />Cuneo, Italia
						</p>
					</Row>
					<Row className="text-center" style={rowStyle}>
						<h4>Email:</h4>
						<p>
							<a href={`mailto:${emailAddress}`} style={{ color: "black" }}>{emailAddress}</a>
						</p>
					</Row>
					<Row className="text-center" style={rowStyle}>
						<h4>Phone:</h4>
						<p>
							Andrea: <a href={`tell:${telNumber}`} style={{ color: "black" }}>{telNumber}</a>
						</p>
					</Row></Card.Body></Card>
			</Container>
		</div >
	);
};
